/* 🤖 this file was generated by svg-to-ts */
export const matIconOndemandVideo: {
  name: 'ondemand-video';
  data: string;
} = {
  name: 'ondemand-video',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"/></svg>`
};
